const d3 = require("d3");

class DashboardVisual {
    constructor(svg, currData) {
        this.svg = svg;
    }

    initChart(baseOpacities, baseColours, currData) {
        this.baseOpacities = baseOpacities.concat([0.2]);
        this.baseColours = baseColours.concat(["black"]);
        currData = currData.concat([0]);

        var self = this;


        this.pie = d3
            .pie()
            .value(function (d) {
                return d;
            })
            .sort(null);

        this.arc = d3.arc().innerRadius(95).outerRadius(120);

        //Get svg size
        var width = this.svg.node().getBoundingClientRect().width / 2;
        var height = this.svg.node().getBoundingClientRect().height / 2;

        width = 150;
        height = 150;

        var opacityDuration = 500;

        this.chart = this.svg.append("g").attr("transform", "translate(" + width + "," + height + ")");


        this.path = this.chart.selectAll("path").data(this.pie(currData));
        var pathEnter = this.path
            .enter()
            .append("path")
            .attr("fill", function (d, i) {
                return self.baseColours[i];
            })
            .attr("opacity", function (d, i) {
                return self.baseOpacities[i];
              })
            .each(function (d) {
                this._current = d;
            })
            .on("mouseover", function (d, i) {

                if(i.index == currData.length - 1) {
                    return;
                }



                // On mouseover, reduce the opacity of all arcs
                self.path.transition().duration(opacityDuration).style("opacity", 0.2);

                // Then, increase the opacity of the current arc
                d3.select(this).transition().duration(opacityDuration).style("opacity", self.baseColours[i]);

                // Show the label for the current arc
                self.chart
                    .selectAll("text.label")
                    .filter((d, index) => index === i.index)
                    .transition()
                    .duration(opacityDuration)
                    .style("opacity", 1);
            })
            .on("mouseout", function (d, i) {
                // On mouseout, restore the opacity of all arcs
                self.path.transition().duration(opacityDuration).style("opacity", (d, i) => self.baseOpacities[i]);
                self.chart.selectAll("text.label").transition().duration(opacityDuration).style("opacity", 0);

                // Hide the label for the current arc
                // self.chart.selectAll("text").filter((d, index) => index === i).style("visibility", "hidden");
            });

        this.path = this.path.merge(pathEnter);

        this.path.exit().remove();

        // Add spacing between arcs
        var arcSpacing = 0.2;
        var arcPadAngle = arcSpacing / this.pie(currData).length;
        this.arc.padAngle(arcPadAngle);

        this.path.transition().duration(750).attrTween("d", arcTween);
        // Store the displayed angles in _current.
        // Then, interpolate from _current to the new angles.
        // During the transition, _current is updated in-place by d3.interpolate.
        function arcTween(a) {
            var i = d3.interpolate(this._current, a);
            this._current = i(0);
            return function (t) {
                return self.arc(i(t));  
            };
        }

        // Add chart labels for each arc with the value of the arc placed on the outside of the arc
        this.chart
            .selectAll("text")
            .data(this.pie(currData))
            .enter()
            .append("text")
            .classed("label", true)
            .attr("dy", "0.35em")
            .attr("pointer-events", "none")
            .attr("text-anchor", function (d) {
                // Set text-anchor based on the side of the pie chart
                return "middle";
            })
            .style("opacity", 0) // Start with opacity 0
            .text(function (d) {
                return self.valToString(d.value); // Round the numbers
            })
            .style("font-family", "Open Sans")
            .style("font-size", "17px")
            .style("font-weight", "600")
            .style("fill", function (d, i) {
                return baseColours[i]; // Use the same color as the arc
            });



        this.arcTween = arcTween;

        this.updatePie(currData);

    }

    updatePie(currData) {
        
        var emptyLabel = 1;

        for(var i in currData) {
            if(currData[i] > 0) {
                emptyLabel = 0;
                break;
            }
        }
        var radius = 120;

        currData = currData.concat([emptyLabel]);
        var self = this;

        var easeMethod = d3.easeLinear;
        easeMethod = d3.easeCubicInOut;


        var pos = d3.arc().innerRadius(radius + 20).outerRadius(radius + 20); 
        var labelr = 135;
        
        this.chart.selectAll("path").data(this.pie(currData)).transition().ease(easeMethod).duration(300).attrTween("d", this.arcTween);
        this.chart
            .selectAll("text")
            .data(this.pie(currData))
            .attr("dy", ".35em")
            .attr("transform", function(d) {
                var c = self.arc.centroid(d),
                    x = c[0],
                    y = c[1],
                    // pythagorean theorem for hypotenuse
                    h = Math.sqrt(x*x + y*y);
                return "translate(" + (x/h * labelr) +  ',' +
                   (y/h * labelr) +  ")"; 
            })
            .style("text-anchor", function(d) {
                var rads = ((d.endAngle - d.startAngle) / 2) + d.startAngle;
                if ( (rads > 7 * Math.PI / 4 && rads < Math.PI / 4) || (rads > 3 * Math.PI / 4 && rads < 5 * Math.PI / 4) ) {
                  return "middle";
                } else if (rads >= Math.PI / 4 && rads <= 3 * Math.PI / 4) {
                  return "start";
                } else if (rads >= 5 * Math.PI / 4 && rads <= 7 * Math.PI / 4) {
                  return "end";
                } else {
                  return "middle";
                }
              })
            .text(function (d) {
                return self.valToString(d.value); // Round the numbers
            });
    }
}

module.exports = { DashboardVisual };